import SuperCluster from "./SuperCluster";

export default class SuperClustersGenerator {
    // Public:
    constructor(clusters) {
        this._clusters = clusters;
    }

    compute() {
        this._superClusters = [];
        let clusters = this._clusters;
        this._classifiedClusters = [];
        for (let i = 0; i < clusters.length; i++) {
            if (this.isClusterNotClassified(i)) {
                const cluster = clusters[i];
                this._indexList = [];
                this._indexStack = [cluster.id];
                while (!this.isStackEmpty()) {
                    const index = this._indexStack[0];
                    if (this.isClusterNotInList(index)) {
                        this.addClusterToList(index);
                        this.addSiblingsToStack(index);
                    }
                    this._indexStack.shift();
                }
                this.createSuperCluster();
            }
        }
        return this._superClusters;
    }

    // Private:
    addClusterToList(index) {
        this._indexList.selfConcat(index);
        this._classifiedClusters.push(index);
    }

    addSiblingsToStack(index) {
        let clusters = this._clusters;
        let siblings = clusters[index].siblings;
        let indexStack = this._indexStack;
        indexStack.selfConcat(siblings);
        this._indexStack = indexStack;
    }

    createSuperCluster() {
        let id = this.computeSuperClusterId();
        let indices = this._indexList;
        let cParams = {
            id: id,
            indices: indices,
            clusters: this._clusters,
        };
        let superCluster = new SuperCluster(cParams);
        this._superClusters.push(superCluster);
    }

    isClusterNotClassified(index) {
        const classifiedClusters = this._classifiedClusters;
        const cluster = this._clusters[index];
        const id = cluster.id;
        if (classifiedClusters.indexOf(id) === -1) {
            return true;
        } else {
            return false;
        }
    }

    isClusterNotInList(index) {
        let indices = this._indexList;
        if (indices.indexOf(index) === -1) return true;
        else return false;
    }

    isStackEmpty() {
        if (this._indexStack.length === 0) return true;
        else return false;
    }

    computeSuperClusterId() {
        let N = this._superClusters.length;
        let id = N + 1;
        return id;
    }
}
